<template>
    <div class="mb-4">
        <div class="w-full lg:w-1/2 float-right text-center">
            <h3 class="inline-block mx-auto p-1 px-8 -mb-1 rounded-t-lg border border-b-0 text-center relative z-20"
                :class="'color-background-' + visual_type"
            >
                {{ title }}

                <span class="block uppercase w-full -mt-1 text-xs">Related Scores</span>
            </h3>

            <div class="w-full flex flex-wrap text-xs text-center border h-96 rounded p-2 pb-0 lg:p-4 lg:pb-0 relative min-h-56 relative"
                :class="'color-background-' + visual_type">
                <div class="w-1/3 flex flex-col justify-end h-full px-2">
                    <div class="text-sm pt-2 w-full rounded-t-lg relative"
                        :class="'color-' + visual_type"
                        :style="{ height: best_fit_value + '%' }"
                    >
                        <strong class="rounded-full absolute top-0 mx-auto w-6 h-6 left-0 right-0 -mt-4 bg-white">
                            {{ best_fit_value }}
                        </strong>
                    </div>
                    <div class="flex h-16 justify-center content-center items-center leading-tight px-2 pt-1" style="background-color: rgba(255, 255, 255, 0.4);">
                        Best-Fit Visual Type™
                        Preferences
                    </div>
                </div>

                <div class="w-1/3 flex flex-col justify-end h-full px-2">
                    <div class="text-sm pt-2 w-full rounded-t-lg relative"
                        :class="'color-' + visual_type"
                        :style="{ height: self_discovery_value + '%' }"
                    >
                        <strong class="rounded-full absolute top-0 mx-auto w-6 h-6 left-0 right-0 -mt-4 bg-white">
                            {{ self_discovery_value }}
                        </strong>
                    </div>
                    <div class="flex h-16 justify-center content-center items-center leading-tight px-2 pt-1" style="background-color: rgba(255, 255, 255, 0.4);">
                        Self-Discovery Activity
                        Vote Tally
                    </div>
                </div>

                <div class="w-1/3 flex flex-col justify-end h-full px-2">
                    <div class="text-sm pt-2 w-full rounded-t-lg relative"
                        :class="'color-' + visual_type"
                        :style="{ height: verified_personality_value + '%' }"
                    >
                        <strong class="rounded-full absolute top-0 mx-auto w-6 h-6 left-0 right-0 -mt-4 bg-white">
                            {{ verified_personality_value }}
                        </strong>
                    </div>
                    <div class="flex h-16 justify-center content-center items-center leading-tight px-2 pt-1" style="background-color: rgba(255, 255, 255, 0.4);">
                        Verified Personality
                        Pattern Average
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {},
        visual_type: {},
        best_fit_value: {},
        self_discovery_value: {},
        verified_personality_value: {},
    },
}
</script>
